var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.21 0h-5.612a.703.703 0 0 0-.703.703v9.74c0 1.208.98 2.188 2.188 2.188h7.214a.703.703 0 0 0 .703-.703V3.907zM3.79 24h5.612a.703.703 0 0 0 .703-.703v-9.74c0-1.208-.98-2.188-2.188-2.188H.702a.7.7 0 0 0-.702.703v8.021zM.001 3.791v5.613c0 .388.315.703.703.703h9.74c1.209 0 2.188-.98 2.188-2.188V.705a.703.703 0 0 0-.703-.703H3.91zM24 20.21v-5.613a.703.703 0 0 0-.703-.702h-9.74c-1.209 0-2.188.98-2.188 2.187v7.215c0 .387.315.702.703.702h8.02z"
  })));
};
export default SvgLogo;